import { Component, Input } from '@angular/core';
import { CalendarComponentInput } from './calendar-input';

@Component({
  selector: 'libero-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  standalone: false
})
export class CalendarComponent {
  @Input() public calendarData!: CalendarComponentInput[];

  public dayTypes: string[] = [
    'trade-day',
    'estate-trade-day',
    'holiday-cz',
    'holiday-other',
  ];

  public get offsetDays(): number[] {
    const firstDayPosition = this.calendarData[0].day.day();

    let count = 0;

    switch (firstDayPosition) {
      case 0:
        count = 6;
        break;
      default:
        count = firstDayPosition - 1;
        break;
    }

    return [...Array(count).keys()];
  }
}
